import { IconProps } from '@/components/Icons/types/IconInterface';
import cn from '@/utils/cn';
import { iconVariant } from '@/components/Icons/iconVariant';
import React from 'react';

const InternationalIcon = ({ size, variant, className }: IconProps) => {
  return (
    <svg
      className={cn(iconVariant({ variant, size, className }))}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="25" cy="25" r="24.5" fill="#11E8C2" stroke="#11E8C2" />
      <path
        d="M28.7498 21.25C29.164 21.25 29.4998 21.5858 29.4998 22C29.4998 23.1201 29.0077 24.1263 28.2304 24.8123C27.9199 25.0864 27.4459 25.0569 27.1718 24.7463C26.8977 24.4357 26.9273 23.9618 27.2378 23.6877C27.7062 23.2743 27.9998 22.6719 27.9998 22C27.9998 21.5858 28.3356 21.25 28.7498 21.25Z"
        fill="#010F55"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 15.25C19.6152 15.25 15.25 19.6152 15.25 25C15.25 30.3848 19.6152 34.75 25 34.75C30.3848 34.75 34.75 30.3848 34.75 25C34.75 19.6152 30.3848 15.25 25 15.25ZM17.5749 28.6002C18.912 31.3527 21.7344 33.25 25 33.25C25.6623 33.25 26.3063 33.172 26.9234 33.0246C26.6364 32.2603 25.9044 31.75 25.0828 31.75C24.6022 31.75 24.1921 31.4026 24.1131 30.9285L24.0401 30.4907C23.9461 29.9263 24.2906 29.3813 24.8408 29.2241L25.8295 28.9416C26.2567 28.8195 26.6131 28.5237 26.8119 28.1263L26.8484 28.0533C27.0945 27.561 27.5977 27.25 28.1481 27.25C28.5335 27.25 28.9031 27.4031 29.1756 27.6756L29.5 28H30.1283C30.9669 28 31.724 28.4646 32.1108 29.1857C32.8347 27.9587 33.25 26.5278 33.25 25C33.25 20.7018 29.963 17.1713 25.7656 16.7851C25.81 17.048 25.9468 17.289 26.1548 17.4623L27.2234 18.3528C27.6651 18.7209 27.7582 19.3628 27.4393 19.8411L26.9282 20.6077C26.6507 21.024 26.2423 21.3359 25.7676 21.4941L25.6254 21.5415C24.9327 21.7724 24.6492 22.5988 25.0542 23.2063C25.4237 23.7605 25.2238 24.5131 24.6281 24.811L22 26.125L22.4234 27.1835C22.608 27.645 22.408 28.171 21.9634 28.3933C21.5503 28.5999 21.0486 28.4814 20.7714 28.1119L20.0922 27.2062C19.5904 26.5372 18.5599 26.6301 18.1859 27.3781L17.5749 28.6002Z"
        fill="#010F55"
      />
    </svg>
  );
};

export default InternationalIcon;
